import {withStyles} from 'common/util/react';
import {react2panel} from 'common/util/react2panel';

import {Toggle} from './';
import css from './index.module.styl?inline';

export const ToggleEl = react2panel(`mp-toggle`, withStyles(Toggle, css));
